import React, { Component } from 'react';
import { Route, BrowserRouter, Switch, Redirect } from 'react-router-dom';
import DefaultLayout from "./Components/DefaultLayout/DefaultLayout"
// import './Assets/js/bootstrap.bundle.min.js';
import LogIn from "./Views/Auth/Login.js"
// import './Assets/css/bootstrap.min.css';
import cookie from 'react-cookies'
import 'aos/dist/aos.css';
import AOS from 'aos';
import './App.css';


// import './Assets/css/bootstrap.min.css';
// import './Assets/js/bootstrap.bundle.min.js';

class App extends Component {

  componentDidMount() {
    AOS.init({
      once: true,
    });
  }

  render() {
    let token = cookie.load('ElmoaserToken') ? cookie.load('ElmoaserToken') : null;
    return (
      <BrowserRouter>
        <Switch>
          <Route exact path="/login" component={LogIn} />
          <Route exact path="/Elmoaser/:value" component={DefaultLayout} />
        </Switch>
        {!token &&  <Redirect to="/login" />}
      </BrowserRouter>
    );
  }
}

export default App;